import { i18n } from "../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import inventoryCaseApi, {
  CaseConsumeQuantityRequest, CaseData
} from '../../apis/inventoryCase.api'
import workOrderApi, { WorkOrderData } from '../../apis/workOrder.api'
import workOrderService from '../../services/workOrder.service'
import alertService from '../../services/alert.service'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import CardButton from '../../components/CardButton'
import InputText from '../../components/InputText'
import Row from '../../components/Row/Row'
import SearchPicker, { SearchPickerOption } from '../../components/SearchPicker'
import InputScan from '../../components/InputScan'

interface Props {
  onCaseChange: (sourceCase: CaseData | null) => void
  onResetForm: () => void
}

interface State {
  caseCode: string
  workOrder: string
  quantity: string
  caseId: number | null
  workOrderId: number | null
  workOrders: WorkOrderData[]
}

export default class TransferToProduction extends Component<Props, State> {
  initialState: State = {
    caseCode: '',
    workOrder: '',
    quantity: '',
    caseId: null,
    workOrderId: null,
    workOrders: []
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputScan = this.handleInputScan.bind(this)
    this.handleWorkOrderSearch = this.handleWorkOrderSearch.bind(this)
    this.handleWorkOrderSelect = this.handleWorkOrderSelect.bind(this)
    this.handleWorkOrderBlur = this.handleWorkOrderBlur.bind(this)
    this.handleTransferClick = this.handleTransferClick.bind(this)
  }

  get workOrderOptions () {
    return workOrderService.searchOptions(this.state.workOrders)
  }

  reset () {
    this.setState(this.initialState)
    this.props.onResetForm()
  }

  handleCaseScan (code: string) {
    if (!code) return
    inventoryCaseApi.readByCode(code, inventoryCase => {
      if (!inventoryCase) return
      this.setState({
        caseId: inventoryCase.id,
        quantity: String(inventoryCase.quantity)
      })
      this.props.onCaseChange(inventoryCase)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'workOrder') {
      this.setState({ workOrderId: null, workOrder: value })
    } else if (name === 'caseCode') this.setState({ caseCode: value })
    else if (name === 'quantity') this.setState({ quantity: value })
  }

  handleInputScan (name: string, value: string) {
    if (name === 'caseCode') {
      this.handleCaseScan(value)
    }
  }

  handleWorkOrderSearch (name: string, code: string) {
    workOrderApi.searchByCode(code, workOrders => {
      if (!workOrders) return
      this.setState({ workOrders })
    })
  }

  handleWorkOrderSelect (name: string, option: SearchPickerOption) {
    const workOrderId = option.id as number
    const workOrder = workOrderService.find(this.state.workOrders, workOrderId)
    if (!workOrder) return
    this.setState({ workOrders: [], workOrderId })
  }

  handleWorkOrderBlur (name: string) {
    this.setState({ workOrders: [] })
  }

  handleTransferConfirm () {
    const { workOrderId, quantity, caseId } = this.state
    if (!caseId) return
    const payload: CaseConsumeQuantityRequest = {}
    if (workOrderId) payload.workOrder = workOrderId
    if (quantity) payload.quantity = Number(quantity)
    inventoryCaseApi.consumeQuantity(caseId, payload, consume => {
      if (!consume) return
      alertService.success('Successfully transferred to production')
      this.reset()
    })
  }

  handleTransferClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review and confirm transfer.'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.handleTransferConfirm()
    }
    confirmService.push(confirm)
  }

  render () {
    return (
      <Fragment>
        <Row column={2}>
          <InputScan
            name="caseCode"
            value={this.state.caseCode}
            label={i18n("Scan case code")}
            autofocus={true}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
          <SearchPicker
            name="workOrder"
            value={this.state.workOrder}
            options={this.workOrderOptions}
            label={i18n("Work order")}
            onSearch={this.handleWorkOrderSearch}
            onChange={this.handleInputChange}
            onSelect={this.handleWorkOrderSelect}
            onBlur={this.handleWorkOrderBlur} />
          <InputText
            name="quantity"
            value={this.state.quantity}
            label={i18n("Quantity")}
            onChange={this.handleInputChange} />
        </Row>
        <CardButton
          proceedText={i18n("Transfer")}
          onProceedClick={this.handleTransferClick} />
      </Fragment>
    )
  }
}
